var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00391 20V8H2.00391V6H5.00391C5.5562 6 6.00391 6.44772 6.00391 7V19H18.4423L20.4423 11H8.00391V9H21.7231C22.2754 9 22.7231 9.44772 22.7231 10C22.7231 10.0818 22.7131 10.1632 22.6932 10.2425L20.1932 20.2425C20.082 20.6877 19.682 21 19.2231 21H5.00391C4.45163 21 4.00391 20.5523 4.00391 20ZM6.00391 27C4.89934 27 4.00391 26.1046 4.00391 25C4.00391 23.8954 4.89934 23 6.00391 23C7.10848 23 8.00391 23.8954 8.00391 25C8.00391 26.1046 7.10848 27 6.00391 27ZM18.0039 27C16.8993 27 16.0039 26.1046 16.0039 25C16.0039 23.8954 16.8993 23 18.0039 23C19.1085 23 20.0039 23.8954 20.0039 25C20.0039 26.1046 19.1085 27 18.0039 27Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.13bc1e0b51481fba6e68b64f325f2193.svg";
export { ForwardRef as ReactComponent };